import welcomeImage from "../../assets/images/msgflow.png";

function HomeLandingPage() {
return (
    <>
    <div>
      <h1>Welcome!</h1>
      <p>You are now signed in to the Carafin Customer Campaign Management System (CCMS).</p>
    </div>
    <img 
    src={welcomeImage} 
    alt="Welcome" 
    style={{ width: "900px", borderRadius: "0px", marginTop: "50px" }} 
    />
    </>
  );

}

export default HomeLandingPage;